import store from "../../../store"
import { axiosWrapper } from "../../axios_old"
import { Data } from "../../formating"
import preparePayload from "../preparePayload"

const dependent = async (args) => {
	const { user, data, action, setNotification, options } = args
	try {
		let newData = {}
		if (action === "GET_ALL") {
			const { data: dependentsAPI } = await axiosWrapper("GET", "dependent", null, null, user.token)
			const dependents = new Map()
			dependentsAPI.forEach((dep) => {
				dependents.set(dep.id, Data.Dependent({ dependent: dep }))
			})
			if (options && options.includes("GET_ALL_PATIENTS"))
				dependents.set(user.patientId, {
					...user,
					id: user.patientId,
					name: user.fullName,
					fullName: user.fullName,
					tableValues: {
						name: user.fullName
					}
				})
			return dependents
		} else if (action === "GET_ONE") {
			const { data: dependentsAPI } = await axiosWrapper("GET", "dependent", null, null, user.token)

			const dependent = dependentsAPI.find((dep) => dep.id === data.id)
			return Data.Dependent({ dependent })
		} else if (action === "CREATE") {
			newData = await preparePayload({
				user,
				schema: "dependent",
				data,
				url: "dependent"
			})
			await store.setNotification("notification", true, {
				msg: `Successfully added family member ${data.firstName} ${data.lastName}.`,
				severity: "success",
				isPersist: true
			})
			return {
				...newData,
				patientId: newData.dependentId,
				id: newData.dependentId,
				fullName: `${newData.firstName} ${newData.lastName}`
			}
		} else if (action === "UPDATE") {
			newData = await preparePayload({
				user,
				schema: "dependent",
				data,
				url: `dependent/${data.id}`
			})
			await store.setNotification("notification", true, {
				msg: `Successfully updated family member ${data.firstName} ${data.lastName}.`,
				severity: "success",
				isPersist: true
			})
		} else if (action === "DELETE") {
			await axiosWrapper(`DELETE`, `dependent/${data.id}`, null, null, user.token)
			await store.setNotification("notification", true, {
				msg: `Successfully removed family member ${data.firstName} ${data.lastName}.`,
				severity: "success",
				isPersist: true
			})
		}

		return newData
	} catch (err) {
		console.error(err)
		if (setNotification) {
			await setNotification("notification", true, {
				msg: err?.response?.data?.message,
				severity: "error"
			})
		}
	}
}

export default dependent
